import { Injectable, inject } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpErrorResponse, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { EventManager, EventWithContent } from '../service/event-manager.service';
import { AlertErrorService } from '@core/service/alert-error.service';

@Injectable()
export class ErrorHandlerInterceptor implements HttpInterceptor {
  errorService = inject(AlertErrorService);

  constructor(private eventManager: EventManager) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      tap({
        error: (err: HttpErrorResponse) => {
          this.eventManager.broadcast(new EventWithContent('httpError', err));
        },
      })
    );
  }
}
